import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import th from '../locales/th.json';

export const SUPPORTED_LANGUAGES = ['th', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = 'exam-lang';

function initialLanguage(): Language {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'th' || stored === 'en') return stored;
  return navigator.language.startsWith('th') ? 'th' : 'en';
}

/** ห้าม hardcode ข้อความในคอมโพเนนต์ — ทุก string มาจาก th.json / en.json */
void i18n.use(initReactI18next).init({
  resources: {
    th: { translation: th },
    en: { translation: en },
  },
  lng: initialLanguage(),
  fallbackLng: 'th',
  interpolation: { escapeValue: false },
});

export function setLanguage(language: Language): void {
  localStorage.setItem(STORAGE_KEY, language);
  document.documentElement.lang = language;
  void i18n.changeLanguage(language);
}

document.documentElement.lang = i18n.language;

export default i18n;
